import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "common-h1" }, "Обзор показателей склада", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Добавление", -1)
const _hoisted_3 = { class: "overview__list" }
const _hoisted_4 = { class: "overview__el" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "Партии", -1)
const _hoisted_6 = { class: "overview__value" }
const _hoisted_7 = { class: "overview__el" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "Товары", -1)
const _hoisted_9 = { class: "overview__value" }
const _hoisted_10 = { class: "overview__el" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "Юниты", -1)
const _hoisted_12 = { class: "overview__value" }
const _hoisted_13 = { class: "overview__el" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "Вариации", -1)
const _hoisted_15 = { class: "overview__value" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", null, "Движение юнитов", -1)
const _hoisted_17 = { class: "overview__list" }
const _hoisted_18 = { class: "overview__el" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "На трансфере", -1)
const _hoisted_20 = { class: "overview__value" }
const _hoisted_21 = { class: "overview__el" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "В фотозоне", -1)
const _hoisted_23 = { class: "overview__value" }
const _hoisted_24 = { class: "overview__el" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "На складе", -1)
const _hoisted_26 = { class: "overview__value" }
const _hoisted_27 = { class: "overview__el" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "В зоне сборки", -1)
const _hoisted_29 = { class: "overview__value" }
const _hoisted_30 = { class: "overview__el" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "В зоне отправки", -1)
const _hoisted_32 = { class: "overview__value" }
const _hoisted_33 = { class: "overview__el" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "Отправлено", -1)
const _hoisted_35 = { class: "overview__value" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", null, "Заказы", -1)
const _hoisted_37 = { class: "overview__list" }
const _hoisted_38 = { class: "overview__el" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "Создано", -1)
const _hoisted_40 = { class: "overview__value" }
const _hoisted_41 = { class: "overview__el" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "Подтверждено", -1)
const _hoisted_43 = { class: "overview__value" }
const _hoisted_44 = { class: "overview__el" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "Оплачено", -1)
const _hoisted_46 = { class: "overview__value" }
const _hoisted_47 = { class: "overview__el" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "Собирается", -1)
const _hoisted_49 = { class: "overview__value" }
const _hoisted_50 = { class: "overview__el" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "Собрано", -1)
const _hoisted_52 = { class: "overview__value" }
const _hoisted_53 = { class: "overview__el" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "Отправлено", -1)
const _hoisted_55 = { class: "overview__value" }
const _hoisted_56 = { class: "overview__el" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "overview__title" }, "Получено", -1)
const _hoisted_58 = { class: "overview__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.stats)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", null, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.stats?.lotCount), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.stats?.productCount), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.stats?.storageQhCount), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.stats?.variationCount), 1)
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.stats?.storageQhTransferCount), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.stats?.storageQhPhotozoneCount), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.stats?.storageQhPhysicalCount), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.stats?.storageQhCollectingCount), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.stats?.storageQhShippingCount), 1)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.stats?.storageQhDeliveryCount), 1)
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.stats?.orderCreatedCount), 1)
              ]),
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.stats?.orderConfirmedCount), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.stats?.orderPaidCount), 1)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.stats?.orderCollectingCount), 1)
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.stats?.orderCollectedCount), 1)
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.stats?.orderShippedCount), 1)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.stats?.orderReceivedCount), 1)
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}